import { render, staticRenderFns } from "./ManagerLoginAs.vue?vue&type=template&id=e155b708&scoped=true&"
import script from "./ManagerLoginAs.vue?vue&type=script&lang=js&"
export * from "./ManagerLoginAs.vue?vue&type=script&lang=js&"
import style0 from "./ManagerLoginAs.vue?vue&type=style&index=0&id=e155b708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e155b708",
  null
  
)

export default component.exports